export const LOGIN_PATH = '/login';

export const USER_AUTH_PATH = {
	LOGIN: '/user/login',
	REFRESH_TOKEN: '/user/refresh_token',
	LOGOUT: '/user/logout',
	ME: '/user/me',
};
